import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import UserReport from '../components/report/UserReport';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ account, roomReport, userReport, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <UserReport
          intl={intl}
          dispatch={dispatch}
          userReport={userReport}
          loading={loading}
          roomReport={roomReport}
          account={account}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/UserReport.js